import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {ToastMessageAnimated} from 'react-toastr'

import {dismissNotification} from '../../../application.actions'
import * as selectors from '../../../application.selectors'

class Toast extends React.Component {
  dismiss = id => () => this.props.actions.dismissNotification(id);

  renderMessage(type, {id, message}){
    const messages = Array.isArray(message) ? message : [message];
    return <ToastMessageAnimated
      key={id}
      type={type}
      timeOut={5000}
      className="toast"
      extendedTimeOut={1000}      
      message={messages.map((e, i) => <div key={i}>{e}</div>)}
      onRemove={this.dismiss(id)}
      showAnimation="animated fadeIn"
      hideAnimation="animated fadeOut"
    />
  }

  render() {
    const {notifications: {error, success, warning}} = this.props;

    return (
      <div aria-live="polite" role="alert" id="toast-container" className="toast-top-full-width">
        {error.map(notification => this.renderMessage('error', notification))}
        {success.map(notification => this.renderMessage('success', notification))}
        {warning.map(notification => this.renderMessage('warning', notification))}
      </div>
    );
  }
}

export default connect(
  state => ({
    notifications: selectors.notifications(state),
    notificationIds: selectors.notificationIds(state)
  }),
  dispatch => ({
    actions: bindActionCreators({dismissNotification}, dispatch)
  })
)(Toast);



// WEBPACK FOOTER //
// ./src/modules/layout/components/Toast.js